import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import type { TextInputSize } from '@interstate/components/TextInput';
import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { KeyboardEventHandler } from 'react';

const BuyRateInput = (props: {
    size: TextInputSize;
    label: string;
    name: string;
    id: string;
    inputPrefix?: string;
    onChange: (e: InterstateOnChangeEvent<string>) => void;
    onBlur: (e: InterstateOnChangeEvent<string>) => void;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    errorMessage: string | undefined;
    hasError: boolean;
    placeholder: string;
    value: string;
    disabled: boolean;
    dataTestId: string;
}) => {
    const {
        size,
        label,
        name,
        id,
        inputPrefix,
        onChange,
        onBlur,
        onKeyDown,
        errorMessage,
        hasError,
        placeholder,
        value,
        disabled,
        dataTestId
    } = props;

    return (
        <TextInput
            size={size}
            label={label}
            name={name}
            id={id}
            inputPrefix={inputPrefix}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            errorMessage={errorMessage}
            hasError={hasError}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            data-testid={dataTestId}
            selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
        />
    );
};

export default BuyRateInput;
